<template>
<div class="chapter">
<div class="inner_page">
<h1 class="parttitle"><a id="page_5"></a><a id="p1"></a><i>The Strand of Family</i></h1>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="center"><img alt="Image" src="images/p5-01.jpg"/></p>
<p style="text-align:center; margin-top:.5pc"></p>
<p class="blockquote"><i>Although it is made of thin, delicate strands, the web is not easily broken. However, a web gets torn every day by the insects that kick around in it, and a spider must rebuild it when it gets full of holes</i>.</p>
<p class="right"><i>—E.B. White</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_part01.vue?3364d741